import React, { FC } from "react";
import { Box, BoxProps } from "theme-ui";

export const LinearGradient: FC<BoxProps> = ({ ...props }: BoxProps) => (
  <Box
    sx={{
      zIndex: 1,
      background: "overlays.linearGradient",
      position: "absolute",
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
    }}
    {...props}
  />
);
